import React, { useState } from "react";
import { CheckCircle2, Circle, MessageSquare, User } from "lucide-react";
import SigortaDosyaNotDrawer from "./SigortaDosyaNotDrawer";

function fmtTarih(iso) {
    if (!iso) return "";
    try {
        return new Date(iso).toLocaleString("tr-TR", {
            day: "2-digit",
            month: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return "";
    }
}

function kaynakEtiket(k) {
    if (k === "yorum") return "Operasyon";
    if (k === "gorusme") return "Görüşme";
    if (k === "tahkim") return "Tahkim";
    return k || "";
}

function stopRowActivation(e) {
    e.stopPropagation();
}

/** Sigorta dosya listesinde gelişmiş not hücresi */
export default function DosyaNotHucre({ row, onRefresh, onDrawerOpenChange }) {
    const [drawerOpen, setDrawerOpen] = useState(false);

    function setDrawer(next) {
        setDrawerOpen(next);
        onDrawerOpenChange?.(next ? row.id : null);
    }
    const text =
        row.son_not_ozeti || row.tahkim_not_ozeti || "";
    const yazan = row.son_not_yazan || "";
    const tarih = fmtTarih(row.son_not_tarihi);
    const kaynak = row.son_not_kaynak || "";
    const bekleyen = Number(row.bekleyen_not_sayisi || 0);
    const okundu = row.son_not_okundu !== false;
    const cozuldu = row.son_not_cozuldu !== false;
    const operasyonBekliyor = kaynak === "yorum" && !cozuldu;

    if (!text && bekleyen === 0) {
        return (
            <div
                data-stop-row-click
                className="min-w-0"
                onMouseDown={stopRowActivation}
                onClick={stopRowActivation}
            >
                <button
                    type="button"
                    onClick={() => setDrawer(true)}
                    className="text-slate-600 text-[11px] italic hover:text-[#D4AF37]"
                >
                    + Not ekle
                </button>
                <SigortaDosyaNotDrawer
                    open={drawerOpen}
                    onClose={() => setDrawer(false)}
                    dosyaId={row.id}
                    dosyaNo={row.dosya_no}
                    onChanged={onRefresh}
                />
            </div>
        );
    }

    return (
        <div
            data-stop-row-click
            className="min-w-0"
            onMouseDown={stopRowActivation}
            onClick={stopRowActivation}
        >
            <button
                type="button"
                onClick={() => setDrawer(true)}
                className={`w-full text-left rounded-lg border px-2 py-1.5 transition hover:border-[#D4AF37]/40 ${
                    operasyonBekliyor
                        ? "border-amber-500/35 bg-amber-500/10"
                        : !okundu && kaynak === "yorum"
                          ? "border-sky-500/30 bg-sky-500/5"
                          : "border-white/10 bg-black/20"
                }`}
            >
                <div className="flex items-center gap-1 flex-wrap mb-0.5">
                    {operasyonBekliyor ? (
                        <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-amber-500/20 text-amber-200 font-semibold">
                            Bekliyor{bekleyen > 1 ? ` · ${bekleyen}` : ""}
                        </span>
                    ) : cozuldu && kaynak === "yorum" ? (
                        <CheckCircle2 className="h-3 w-3 text-emerald-400 shrink-0" />
                    ) : (
                        <Circle className="h-3 w-3 text-slate-600 shrink-0" />
                    )}
                    {kaynak ? (
                        <span className="text-[9px] text-slate-500">{kaynakEtiket(kaynak)}</span>
                    ) : null}
                    {!okundu && kaynak === "yorum" ? (
                        <span className="text-[9px] text-sky-300">Okunmadı</span>
                    ) : null}
                </div>
                <div className="text-[11px] text-slate-300 line-clamp-2 leading-snug">{text}</div>
                {(yazan || tarih) && (
                    <div className="flex items-center gap-1 mt-1 text-[9px] text-slate-500 truncate">
                        <User className="h-2.5 w-2.5 shrink-0" />
                        <span className="truncate">{yazan || "—"}</span>
                        {tarih ? <span className="shrink-0">· {tarih}</span> : null}
                    </div>
                )}
            </button>
            <SigortaDosyaNotDrawer
                open={drawerOpen}
                onClose={() => setDrawer(false)}
                dosyaId={row.id}
                dosyaNo={row.dosya_no}
                onChanged={onRefresh}
            />
        </div>
    );
}
